document.addEventListener('DOMContentLoaded', function () {
  // run only on product pages
  var addToCartForm = document.querySelector('form[action="/cart/add"]');
  if (!addToCartForm) return;

  // optional: disable on small screens
  if (window.matchMedia('(max-width: 767px)').matches) return;

  // --- hard block: never touch header/logo ---
  document
    .querySelectorAll('header .zoomable-media, .site-header .zoomable-media, .header__heading-link.zoomable-media')
    .forEach(function (el) { el.classList.remove('zoomable-media'); });

  // find a reliable product scope (section that contains the form)
  var scope =
    addToCartForm.closest('section[id*="product"], section[class*="product"]') ||
    addToCartForm.closest('main') ||
    addToCartForm.parentElement;

  // target only product gallery containers (not generic .media)
  var nodes = scope.querySelectorAll(
    '.product__media.media, ' +
    '.product__media-item .media, ' +
    '#MainProductMedia .media, ' +
    '.product__modal-opener .product__media.media'
  );

  nodes.forEach(function (node) {
    // ignore thumbnails or anything not the main image
    if (node.closest('.thumbnail, .thumb, [data-thumbnails]')) return;
    // safety: never inside header/footer
    if (node.closest('header, .site-header, footer, .site-footer')) return;

    node.classList.add('zoomable-media');

    node.addEventListener('mousemove', function (e) {
      var img = node.querySelector('img');
      if (!img) return;
      var rect = node.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
    });

    node.addEventListener('mouseleave', function () {
      var img = node.querySelector('img');
      if (img) img.style.transformOrigin = 'center center';
    });
  });
});